<template>
  <div>
    <span class="current-specs">{{ skuSpecNames.length ? `当前规格：${skuSpecNames.join('、')}` : '' }}
    </span>
    <row :gutter="4"
         class="edit-wrapper"
         v-for="(item, index) in list"
         :key="index">
      <h4>
        <Icon type="md-briefcase" />{{$t('pages_products_components_spec_edit_791', [ index + 1 ])}}<span>({{ index + 1 }} / {{ list.length }})</span>
      </h4>
      <i-col :span="24">
        <EditForm
          :wechat-display="product.is_wechat_display"
          v-model="list[index].detail"
          @onEditSkuProp="onEditSkuProp($event, index)" />
        <Divider />
        <Button @click="remove(index)"
                type="default">{{$t('libs_table_render_70')}}</Button>
      </i-col>
    </row>
    <div class="empty-sku"
         @click="onAddSku">
      {{ list.length === 0 ? $t('pages_products_components_spec_edit_792') : ''}}添加规格</div>
  </div>
</template>

<script>
import i18n from '../../../locales/index'

import { map, get, cloneDeep } from "lodash";
import EditForm from "./sku-edit-form";
import Schema from 'async-validator';

const descriptor = {
  huiyuanjia: {
    required: true,
  },
  lingshoujia: {
    required: true,
  },
  jinghuojia: {
    required: true,
  }
};

function prepareSku (sku) {
  const validator = new Schema(descriptor);
  const item = { ...sku };
  validator.validate(item, (errors, fields) => {
    item._valid_ = !errors;
  });
  return item;
}

export default {
  name: "SpecEdit",
  props: ["value", "product", 'single', 'addEnable'],
  components: {
    EditForm
  },
  data () {
    return {
      mode: 'single', // 单一规格还是多规格 single multi
      singleItem: {
        detail: {
          name: this.product.name,
          images: [],
          mall_product_id: null,
          jinghuojia: null,
          lingshoujia: null,
          huiyuanjia: null,
          quantity: null,
          _valid_: false
        }
      },
      checkedMenuItemIndex: 0,
      fullList: [],
      list: [],
      skuSpecNames: []
    };
  },
  computed: {
    checkedItem () {
      if (this.single) {
        return this.singleItem;
      }
      return this.list.find((i, index) => index === this.checkedMenuItemIndex);
    },
    // isSelecteValid () {
    //   return !!this.checkedItem || get(this.value, ['specs', 'length']) === 0;
    // },
    allSkuValid () {
      if (this.single) {
        // return this.singleItem.detail._valid_;
        return true;
      } else {
        return this.list.every(i => i.detail._valid_);
      }
    },
  },
  methods: {
    prev () {
      this.$emit("prev");
    },
    save () {
      if (this.allSkuValid) {
        this.$emit("save", this.single ? [] : this.list);
      } else {
        this.$message.error(i18n.t('pages_products_components_prefer_edit_766'));
      }
    },
    setList () {
      let list;
      if (this.single) {
        // list = this.fullList.filter(item => {
        //   return get(item.detail, ['mall_properties', 'length'], 0) === 0;
        // }).slice(0, 1);
        // const firstItem = list[0] || cloneDeep(this.fullList[0]);
        // list = firstItem ? [firstItem] : [this.singleItem];
        // this.list = list;
        // this.singleItem = list[0];
        // this.singleItem.mall_properties = [];
        // this.checkedMenuItemIndex = 0;

        // this.list = []
        // this.checkedMenuItemIndex = -1;
         list = this.fullList.filter(item => {
          return get(item.detail, ['mall_properties', 'length']) > 0;
        });
        this.list = list;
      } else {
        list = this.fullList.filter(item => {
          return get(item.detail, ['mall_properties', 'length']) > 0;
        });
        this.list = list;
      }

      this.skuSpecNames = this.list.length ? this.list[0].detail.mall_properties.map(item => item.mall_property_name_name) : []
    },
    onEditSkuProp (props, index) {
      this.$emit('onEditSkuProp', props, index)
    },
    onAddSku () {
      this.$emit('addSku');
    },
    submitAddSku (sku) {
      this.list.push({
        detail: sku,
        index: this.list.length,
        title: sku.name,
      });
    },
    editSkuProp (params) {
      const { newSpecs, newName, index } = params
      const props = this.list[index].detail.mall_properties
      newSpecs.map(spec => {
        spec.id = _.find(props, { mall_property_name_id: spec.mall_property_name_id }).id
      })
      this.list[index].detail.mall_properties = newSpecs
      this.list[index].detail.name = newName
      this.list[index].title = newName
    },
    remove (index) {
      const copy = this.list.slice();
      copy.splice(index, 1);
      this.list = copy;
      if (copy.length === 0) {
        this.$emit('clearSku')
      }
    },
  },
  watch: {
    value: {
      immediate: true,
      handler (val) {
        const single = this.single;
        this.mode = single ? 'single' : 'multi';
        const menu = map(val, (item, index) => {
          return {
            index,
            title: item.name,
            detail: prepareSku(item),
          };
        });
        this.fullList = menu;
        this.$nextTick(() => {
          this.setList();
        });
      }
    },
    single: {
      immediate: true,
      handler (single) {
        this.setList();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.empty-sku {
  color: #666;
  font-size: 20px;
  border: 1px dashed #ddd;
  line-height: 100px;
  text-align: center;
  box-sizing: border-box;
  cursor: pointer;
  &:hover {
    background: #f5f5f5;
  }
}

.current-specs {
  margin-bottom: 10px;
  display: inline-block;
}

.edit-wrapper {
  flex: auto !important;
  overflow: auto;
  padding: 24px;
  display: flex;
  align-items: stretch;
  flex-direction: column;
  background: #f5f5f5;
  margin-bottom: 20px;

  > h4 {
    margin-bottom: 20px;
    > span {
      color: #666;
      font-weight: normal;
      margin-left: 20px;
    }
  }
  .footer {
    background: #fff;
    border-top: 1px solid #f5f5f5;
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    height: 60px;
    line-height: 60px;
    text-align: center;
  }
}

.menu {
  list-style: none;
  padding: 0 30px 20px 0;
  overflow: auto;
  flex: auto;
  li {
    padding: 12px 0;
    // height: 45px;
    line-height: 1.5;
    font-size: 14px;
    color: #333;
    cursor: pointer;
    text-indent: 10px;
    position: relative;
    padding-left: 20px;
    padding-right: 12px;
    a {
      cursor: pointer;
    }
    &:hover {
      color: #fff;
      background: rgba(58, 169, 243, 0.6);
    }
    &:nth-of-type(n + 2) {
      border-top: 1px solid #ddd;
    }
    &.active {
      color: #fff;
      background: rgb(58, 169, 243);
      a {
        color: yellow;
      }
    }
    .icon {
      position: absolute;
      left: 0;
      margin-left: -25px;
      top: 12px;
    }
    &.add-multi-spec {
      text-align: center;
      font-size: 14px;
      text-indent: -30px;
      border: 1px dashed #ddd;
    }
  }
}
.empty {
  height: 200px;
  line-height: 200px;
  text-align: center;
  font-size: 30px;
  font-weight: bold;
  color: #999;
}

.single-mode-ul {
  font-size: 24px;
  line-height: 60px;
  text-align: center;
  text-indent: -30px;
  color: #ddd;
}
</style>
